import React, { Suspense, useEffect, useState } from "react";

import homePagePayload from "../../config/homePayload";
import homePageAPI from "../../api/homePageApi";

import CouponFlash from "./CouponFlash";
import { Link } from "react-router-dom";
import { Row, Col, Container } from "react-bootstrap";

import {
  Swiper,
  SwiperSlide,
  Autoplay,
  Navigation,
  Pagination,
} from "./Shared/CustomSwiper";
import { FaBox, FaCheckCircle, FaHeadset } from "react-icons/fa";

const Product = React.lazy(() => import("../products/Card"));
const Testimonials = React.lazy(() => import("../testimonials/Card"));
const CategoryCard = React.lazy(() => import("../categories/Card"));
const Blog = React.lazy(() => import("../blogs/Card"));
const Banner = React.lazy(() => import("./Banner"));

function Home() {
  const [coupons, setCoupons] = useState([]);
  const [categories, setCategories] = useState([]);
  const [testimonials, setTestimonials] = useState([]);
  const [products, setProducts] = useState([]);
  const [topSellerProducts, setTopSellerProducts] = useState([]);
  const [blogs, setBlogs] = useState([]);
  const [topBanners, setTopBanners] = useState([]);
  const [middleBanners, setMiddleBanners] = useState([]);
  const firstMiddleBanner = middleBanners[0];
  const secondMiddleBanner = middleBanners[1];

  useEffect(() => {
    fetchHomePageDetails();
  }, []);

  const CACHE_TIME = 3 * 60 * 1000;

  const applyData = (data) => {
    setTopBanners(data?.banners?.filter((b) => b.position === "top"));
    setMiddleBanners(data?.banners?.filter((b) => b.position === "middle"));
    setCoupons(data?.coupons);
    setCategories(data?.categories);
    setTestimonials(data?.testimonials);
    setBlogs(data?.blogs);
    setProducts(data?.products);
    setTopSellerProducts(data?.topSellerProducts);
  };

  const fetchHomePageDetails = async () => {
    try {
      const cached = sessionStorage.getItem("homeData");
      const parsed = cached ? JSON.parse(cached) : null;

      if (parsed) applyData(parsed.data);

      if (!parsed || Date.now() - parsed.timestamp > CACHE_TIME) {
        const res = await homePageAPI.homePage(homePagePayload);
        if (res.code === 200) {
          sessionStorage.setItem(
            "homeData",
            JSON.stringify({ data: res.data, timestamp: Date.now() }),
          );
          if (!parsed) applyData(res.data); // only update state if no cache was shown
        }
      }
    } catch (error) {
      console.error("Home API Error:", error);
    }
  };

  return (
    <>
      {/* show banners */}
      {topBanners && topBanners.length > 0 && (
        <Swiper
          modules={[Navigation, Pagination, Autoplay]}
          slidesPerView={1}
          pagination={{ clickable: true }}
          autoplay={{ delay: 3000 }}
          loop={true}
        >
          {topBanners.map((banner, index) => (
            <SwiperSlide key={index}>
              <Banner item={banner} />
            </SwiperSlide>
          ))}
        </Swiper>
      )}

      {/* coupon listing */}
      {/* Coupon Bar */}
      {coupons && coupons.length > 0 && (
        <div className="coupon-section py-4">
          <div className="container">
            <Suspense fallback={<div></div>}>
              {coupons.map((coupon, index) => (
                <React.Fragment key={index}>
                  <CouponFlash item={coupon}  />
                </React.Fragment>
              ))}
            </Suspense>
          </div>
        </div>
      )}

      {/* category listing */}
      {categories && categories.length > 0 && (
  <section className="custom-category-section main-section">
    <div className="container">
      {/* Title with Funky Style */}
      <h2 className="section-title text-center mb-5" style={{ 
        fontFamily: "'Bebas Neue', cursive", 
        fontSize: "3.5rem",
        letterSpacing: "2px"
      }}>
        Shop by <span style={{ color: "var(--f-purple)", background: "var(--f-yellow)", padding: "0 10px" }}>Category</span>
      </h2>

      <Swiper
        modules={[Autoplay, Pagination]}
        spaceBetween={20} // Cards ke beech ka gap
        slidesPerView={2} // Mobile pe 2 dikhenge
        autoplay={{ delay: 3000, disableOnInteraction: false }}
        pagination={{ clickable: true }}
        breakpoints={{
          // Desktop screens
          992: {
            slidesPerView: 4,
            spaceBetween: 30,
          },
          // Tablet screens
          768: {
            slidesPerView: 3,
            spaceBetween: 20,
          },
        }}
        className="category-swiper pb-5"
      >
        {categories.map((category, index) => (
          <SwiperSlide key={index}>
            <CategoryCard item={category} />
          </SwiperSlide>
        ))}
      </Swiper>
    </div>
  </section>
)}

      {/* bestsellers */}
      {products && products.length > 0 && (
  <section className="bestsellers-section main-section py-5">
    <div className="container">
      {/* Header Area with Funky Styling */}
      <div className="d-flex align-items-end justify-content-between mb-5 flex-wrap gap-3">
        <div className="title-wrapper">
          <span className="badge-text">TOP PICKS</span>
          <h2 className="section-title main-heading">Bestsellers</h2>
        </div>
        
        <Link to='/shop' className="funky-view-all">
          <span>View All Collection</span>
          <div className="btn-shadow"></div>
        </Link>
      </div>

      {/* Products Grid */}
      <Row className="g-4">
        <Suspense fallback={<div className="text-center w-100">Loading Vibe...</div>}>
          {products.map((product, index) => (
            <Col lg={3} md={4} sm={6} xs={6} key={product._id || index}>
              <Product item={product} />
            </Col>
          ))}
        </Suspense>
      </Row>
    </div>
  </section>
)}

      {/* middle banners */}
      {firstMiddleBanner && (
  <div className="middle-banner-funky">
    <Container fluid className="p-0">
      <Row className="g-0 align-items-center">
        {/* Left Side: Image with Frame */}
        <Col md={7}>
          <div className="spotlight-image-frame">
            <img
              src={firstMiddleBanner.image}
              alt="Sanwariya Ornaments"
              className="spotlight-img-main"
              loading="lazy"
            />
            {/* Ek chota sticker image ke upar */}
            <div className="image-sticker">PREMIUM QUALITY</div>
          </div>
        </Col>

        {/* Right Side: Text Content */}
        <Col md={5} className="text-center p-md-5 p-4">
          <div className="spotlight-content-inner">
            <span className="badge-text mb-2">SPOTLIGHT</span>
            <h2 className="spotlight-heading">
              {firstMiddleBanner.title}
            </h2>
            <div className="heading-underline"></div>
            <p className="spotlight-description">
              {firstMiddleBanner.subTitle}
            </p>
            <Link to="/shop" className="spotlight-action-btn">
              DISCOVER MORE ⚡
            </Link>
          </div>
        </Col>
      </Row>
    </Container>
  </div>
)}  

      {/* trending */}
      {topSellerProducts && topSellerProducts.length > 0 && (
        <section className="bestsellers-section main-section mt-4">
          <div className="container ">
               <div className="d-flex align-items-end justify-content-between mb-5 flex-wrap gap-3">
        <div className="title-wrapper">
          <span className="badge-text">NEW DROPS</span>
          <h2 className="section-title main-heading">OUR PRODUCTS</h2>
        </div>
        
        <Link to='/shop' className="funky-view-all">
          <span>View All Collection</span>
          <div className="btn-shadow"></div>
        </Link>
      </div>
            <Row className="g-3">
              <Suspense fallback={<div></div>}>
                {topSellerProducts.map((product, index) => (
                  <Col lg={3} md={6} sm={6} xs={6} key={[product._id || index]}>
                    <Product item={product} />
                  </Col>
                ))}
              </Suspense>
            </Row>
          </div>
        </section>
      )}

      {/* category cta section */}
      {secondMiddleBanner && (
  <section className="cta-banner-funky py-5">
    <Container>
      <Row className="align-items-center g-5">
        {/* LEFT SIDE: MAIN MEDIA */}
        <Col md={7}>
          <div className="banner-media-frame">
            <img
              src={secondMiddleBanner.image}
              alt={secondMiddleBanner.title}
              className="banner-media-img"
              loading="lazy"
            />
            {/* Ek badge image ke upar chadhane ke liye */}
            <div className="media-badge">TOP SELECTION</div>
          </div>
        </Col>

        {/* RIGHT SIDE: CONTENT & CATEGORY SLIDER */}
        <Col md={5}>
          <div className="banner-content-funky">
            <span className="badge-text mb-3">CATEGORIES</span>
            <h2 className="banner-heading-funky">
              {secondMiddleBanner.title}
            </h2>
            <p className="banner-desc-funky">
              {secondMiddleBanner.subTitle || secondMiddleBanner.sub_title}
            </p>

            {/* SLIDER SECTION */}
            <div className="category-slider-wrapper">
              <Swiper
                spaceBetween={15}
                slidesPerView={3}
                loop
                modules={[Navigation, Autoplay]}
                breakpoints={{
                  0: { slidesPerView: 2.2 },
                  768: { slidesPerView: 2 },
                  1024: { slidesPerView: 3 },
                }}
                className="funky-category-swiper"
                autoplay={{ delay: 2500 }}
              >
                <Suspense fallback={<div></div>}>
                  {categories.map((cat, index) => (
                    <SwiperSlide key={index}>
                      <Link to={`/categories/${cat.slug}`} className="funky-cat-item">
                        <div className="funky-cat-circle">
                          <img
                            src={cat.image}
                            alt={cat.title || cat.name}
                            loading="lazy"
                          />
                        </div>
                        <span className="funky-cat-name">{cat.title || cat.name}</span>
                      </Link>
                    </SwiperSlide>
                  ))}
                </Suspense>
              </Swiper>
            </div>
          </div>
        </Col>
      </Row>
    </Container>
  </section>
)}

      {testimonials && testimonials.length > 0 && (
        <section className="testimonials-section py-5">
          <Container>
              <div className="text-center mb-5 testimonial-header-wrapper">
  {/* Funky Badge */}
  <span className="badge-text">100% HAPPY VIBES</span>
  
  {/* Main Heading */}
  <h2 className="section-title main-heading">What Our Clients Say</h2>
  
  {/* Subtitle with a custom decorative line */}
  <div className="subtitle-container">
    <p className="section-subtitle">Real stories of health, crunch, and trust.</p>
    <div className="funky-line"></div>
  </div>
</div>

            <Swiper
              modules={[Navigation, Autoplay]}
              spaceBetween={20}
              slidesPerView={1}
              navigation={true}
              autoplay={{ delay: 2500 }}
              breakpoints={{
                0: { slidesPerView: 1.2 },
                768: { slidesPerView: 2 },
                1024: { slidesPerView: 3 },
              }}
              className="testimonial-swiper py-4"
            >
              <Suspense fallback={<div></div>}>
                {testimonials.map((testimonial, index) => (
                  <SwiperSlide key={index}>
                    <Testimonials item={testimonial} />
                  </SwiperSlide>
                ))}
              </Suspense>
            </Swiper>
          </Container>
        </section>
      )}

      {blogs && blogs.length > 0 && (
        <section className="blog-section py-5">
          <Container>
              <div className="d-flex align-items-end justify-content-between mb-5 flex-wrap gap-3">
        <div className="title-wrapper">
          <span className="badge-text">OUR BLOGS</span>
          <h2 className="section-title main-heading">BLOGS</h2>
        </div>
        
        <Link to='/shop' className="funky-view-all">
          <span>View All Collection</span>
          <div className="btn-shadow"></div>
        </Link>
      </div>

            <Swiper
              modules={[Pagination, Autoplay]}
              spaceBetween={30}
              slidesPerView={1}
              // autoplay={{ delay: 3500 }}
              pagination={{ clickable: true }}
              breakpoints={{
                768: { slidesPerView: 2 },
                1024: { slidesPerView: 3 },
              }}
              className="blog-swiper py-3"
            >
              <Suspense fallback={<div></div>}>
                {blogs.map((blog, index) => (
                  <SwiperSlide key={blog.id}>
                    <Blog item={blog} />
                  </SwiperSlide>
                ))}
              </Suspense>
            </Swiper>
          </Container>
        </section>
      )}

      {/* featured section */}
      <div className="sanwar-feature-section">
  <div className="container">
    <div className="row g-4">
      {/* Item 1 - Shipping */}
      <div className="col-md-4 col-12">
        <div className="sanwar-feature-box text-center">
          <div className="d-flex justify-content-center">
            <FaBox size={24} className="sanwar-feature-icon" />
          </div>
          <h6 className="sanwar-feature-title">Shipping Across India</h6>
          <p>
            Reliable delivery to your doorstep with standard shipping
            charges applied at checkout.
          </p>
        </div>
      </div>

      {/* Item 2 - Returns */}
      <div className="col-md-4 col-12">
        <div className="sanwar-feature-box text-center">
          <div className="d-flex justify-content-center">
            <FaCheckCircle size={24} className="sanwar-feature-icon" />
          </div>
          <h6 className="sanwar-feature-title">Return & Exchange</h6>
          <p>
            Hassle-free exchanges on eligible products. Shop with
            confidence knowing we’ve got you covered.
          </p>
        </div>
      </div>

      {/* Item 3 - Support */}
      <div className="col-md-4 col-12">
        <div className="sanwar-feature-box text-center">
          <div className="d-flex justify-content-center">
            <FaHeadset size={24} className="sanwar-feature-icon" />
          </div>
          <h6 className="sanwar-feature-title">Support Online</h6>
          <p>
            Our team is ready to assist you anytime via chat, email, or
            call. Get help whenever you need it.
          </p>
        </div>
      </div>
    </div>
  </div>
</div>
    </>
  );
}

export default Home;
